<template>
	<mdb-row class="pb-3 pb-sm-0">
		<div class="d-none d-sm-block mb-sm-3 profile-height w-100">
			<mdb-container class="position-absolute left w-auto">
				<mdb-row :class="clazz">
					<mdb-col>
						<button class="btn-wrapper" @click="TOGGLE_PANEL">
							<img src="/static/logo.png" height="54"/>
						</button>
					</mdb-col>
				</mdb-row>
			</mdb-container>
			<mdb-container class="position-absolute right w-auto">
				<mdb-row>
					<app-profile class="d-inline-block"></app-profile>
				</mdb-row>
			</mdb-container>
		</div>
		<app-profile :class="mobileProfileClass"></app-profile>
	</mdb-row>
</template>

<script>
import AppBreadcrumb from './Breadcrumb.vue'
import AppProfile from './Profile.vue'
import {Container as MdbContainer} from "@/components/mdbvue";
import {mapMutations, mapState} from "vuex";

export default {
	name: 'Header',
	components: {MdbContainer, AppBreadcrumb, AppProfile },
	computed: {
		clazz() {
			return this.hidePanel ? '' : 'd-none'
		},
		mobileProfileClass() {
			return this.hidePanel ? 'd-none' : 'd-inline-block d-sm-none'
		},
		...mapState(['hidePanel'])
	},
	methods: {
		...mapMutations(['TOGGLE_PANEL'])
	}
}
</script>

<style scoped>
.btn-wrapper {
	background: none;
	border: none;
	padding: 0;
}

.profile-height {
	min-height: 48px;
}
</style>
